import { atom } from "jotai";

/**
 * 사이드바 레일(패널이 모두 닫힌 상태) 폭(px). `ApplicationSideBar` 가 `onPanelChange` 의 `totalWidth` 에
 * 레일 몫으로 더한다. 레일 자체를 그리는 `SidebarBase` 는 이 상수가 아니라 자기 기본 폭으로 그린다.
 */
export const SIDEBAR_BASE_WIDTH = 72;

export const activeSidebarModeAtom = atom<"2D" | "3D">("2D");
/**
 * 뷰어별 사이드바 전체 폭(px). 스토어는 폭을 계산하지 않는다 — 2D `TimeSeriesPage`·3D `Inspection3d/Sidebar`
 * 가 `ApplicationSideBar` 의 `onPanelChange` 로 받은 `totalWidth` 를 그대로 기록한다.
 */
export const sidebar2dTotalWidthAtom = atom(SIDEBAR_BASE_WIDTH);
export const sidebar3dTotalWidthAtom = atom(SIDEBAR_BASE_WIDTH);

export const sidebarTotalWidthAtom = atom((get) =>
  get(activeSidebarModeAtom) === "2D"
    ? get(sidebar2dTotalWidthAtom)
    : get(sidebar3dTotalWidthAtom)
);
